import TableComponent from "../Common/TableComponent";

const ServerDetailsAdvancedTab = () => {
    const sections = [
        {
            title: 'ProductSettings',
            data: {
                'Gridofsettings': '',
                'funds in play': '',
                'sweeper op or player': '',
                'additional funds in play': ''  // Added this based on original
            }
        },
        {
            title: 'GameplayWhitelisting',
            data: {
                'grid of ip\'s': ''
            }
        },
        {
            title: 'OperatorSettings',
            data: {
                'grid of oppsettings': ''
            }
        },
        {
            title: 'BEPSettings',
            data: {
                'grid of bepsettings': ''
            }
        },
        {
            title: 'RedirectorSettings',
            data: {
                'grid of redirectorsettings': ''
            }
        }
    ];

    // If we want to add search functionality later, we can add these state variables:
    // const [productSearch, setProductSearch] = useState('');
    // const [BEPSearch, setBEPSearch] = useState('');
    // const [operatorSearch, setOperatorSearch] = useState('');
    // const [redirectorSearch, setRedirectorSearch] = useState('');

    return (
        <div className="details-card">
            {sections.map(section => (
                <div key={section.title}>
                    <h3>{section.title}</h3>
                    <TableComponent data={section.data} />
                    <br />
                </div>
            ))}
        </div>
    );
};

export default ServerDetailsAdvancedTab;